var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgToastError = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 32 32",
  width: "1em",
  height: "1em"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M16 8c4.424 0 8 3.576 8 8s-3.576 8-8 8-8-3.576-8-8 3.576-8 8-8m2.872 4L16 14.872 13.128 12 12 13.128 14.872 16 12 18.872 13.128 20 16 17.128 18.872 20 20 18.872 17.128 16 20 13.128z"
})));
export default SvgToastError;